import type { RoundXp } from '@tt/lobby';

interface Props {
  xp: RoundXp;
  variant?: 'panel' | 'compact';
}

export function RoundXpSummary({ xp, variant = 'panel' }: Props) {
  const leveled = xp.levelAfter > xp.levelBefore;
  return (
    <section className={`round-xp-summary ${variant}`} aria-live="polite" aria-label="XP earned this round">
      <div className="round-xp-main">
        <span className="round-xp-kicker">{leveled ? 'Level up' : 'Account XP'}</span>
        <strong className="round-xp-total">+{xp.total} XP</strong>
        <span className="round-xp-level">
          Lv {xp.levelAfter} · {xp.toNext.current}/{xp.toNext.needed}
        </span>
      </div>
      <div className="round-xp-track" aria-hidden="true">
        <span style={{ width: `${Math.min(100, Math.max(0, (xp.toNext.current / Math.max(1, xp.toNext.needed)) * 100))}%` }} />
      </div>
      <div className="round-xp-items">
        {xp.items.map((it, i) => (
          <span key={`${it.label}-${i}`}>
            {it.label} <b>+{it.amount}</b>
          </span>
        ))}
      </div>
      {leveled && (
        <div className="round-xp-levelup">
          Level {xp.levelBefore} → {xp.levelAfter}
        </div>
      )}
    </section>
  );
}
